import { useEffect } from "react";
import { useSelector } from "react-redux";
import store from "../../stores/store";
import { trans } from "../../lib/utils";

function SelectLayerDropdown(props) {
  const layers = useSelector((state) => store.getState().layers);

  useEffect(() => {}, []);

  return (
    <select
      className="form-select form-select-sm "
      value={props.layer}
      onChange={(e) => {
        if (props.onChange) {
          props.onChange(e);
        }
      }}
    >
      <option value="">{trans("Select a layer")}</option>
      {Object.keys(layers)?.map((el) => {
        let layer = layers[el];

        if (layer.searchable) {
          return <option value={layer.id}>{layer.title}</option>;
        }
      })}
    </select>
  );
}

export default SelectLayerDropdown;
